<template>
  <div v-if="accountStatus === 10">

  <h4>Mein Profil</h4>
  <div class="bg-soft-danger p-3 mb-4">
    Werkstatt-Status: Werkstatt-Konto nicht vorhanden.<br />
    <!-- user content -->
    <div v-if="content.profile_noaccount" class="c1" v-html="content.profile_noaccount"></div>
  </div>
  <div class="mb-4">
    <div v-if="accountInfoFull.linkState == 1">
      <div class="mb-2">
        <span class="badge badge-secondary">Werkstatt-Konto nicht verknüpft</span>
      </div>
      <!-- user content -->
      <div v-if="content.profile_accountnotlinked" class="c2" v-html="content.profile_accountnotlinked"></div>
    </div>
    <div v-if="accountInfoFull.linkState == 2">
      <div class="mb-2">
        <span class="badge badge-success"><i class="fa fa-check-square-o" aria-hidden="true"></i> Werkstatt-Konto verknüpft</span>
      </div>
      <!-- user content -->
      <div v-if="content.profile_accountlinked" class="c2" v-html="content.profile_accountlinked"></div>
    </div>
  </div>

  <form @submit.prevent="onAccount()">

    <div class="form-row mb-2">

      <div class="form-group col-sm-6">
        <label for="Salutation">Anrede</label>
        <select v-model="accountInfo.salutation" class="form-control" id="Salutation" name="Salutation">
          <option value="Frau">Frau</option>
          <option value="Herr">Herr</option>
        </select>
      </div>

      <div class="form-group col-sm-6">
        <label for="Lastname">Nachname<span class="text-danger">*</span></label>
        <input class="form-control" v-model="accountInfo.lastName" placeholder="Nachname" type="text" data-val="true" id="Lastname" name="Lastname" />
        <div class="invalid-feedback d-block" v-if="formdata_errors_account.includes('lastName')">
          Bitte geben Sie Ihren Nachnamen an.
        </div>
      </div>


      <div class="form-group col-sm-6">
        <label for="Firstname">Vorname<span class="text-danger">*</span></label>
        <input class="form-control" v-model="accountInfo.firstName" placeholder="Vorname" type="text" id="Firstname" name="Firstname" value="" />
        <div class="invalid-feedback d-block" v-if="formdata_errors_account.includes('firstName')">
          Bitte geben Sie Ihren Vornamen an.
        </div>
      </div>

      <div class="form-group col-sm-6">
        <label for="AdditionalText">Zusatztext</label>
        <input class="form-control" v-model="accountInfo.additionalText" placeholder="Zusatztext" type="text" id="AdditionalText" name="AdditionalText" value="" />
      </div>

      <div class="form-group col-sm-6">
        <label for="Street">Straße<span class="text-danger">*</span></label>
        <input class="form-control" v-model="accountInfo.street" placeholder="Straße" type="text" id="Street" name="Street" value="" />
        <div class="invalid-feedback d-block" v-if="formdata_errors_account.includes('street')">
          Bitte geben Sie Ihre Straße an.
        </div>
      </div>

      <div class="form-group col-sm-6">
        <label for="ZipCode">PLZ<span class="text-danger">*</span></label>
        <input class="form-control" v-model="accountInfo.zipCode" placeholder="Postleitzahl" type="text" id="ZipCode" name="ZipCode" value="" />
        <div class="invalid-feedback d-block" v-if="formdata_errors_account.includes('zipCode')">
          Bitte geben Sie Ihre PLZ an.
        </div>
      </div>

      <div class="form-group col-sm-6">
        <label for="Town">Ort<span class="text-danger">*</span></label>
        <input class="form-control" v-model="accountInfo.city" placeholder="Ort" type="text" id="Town" name="Town" value="" />
        <div class="invalid-feedback d-block" v-if="formdata_errors_account.includes('city')">
          Bitte geben Sie Ihren Ort an.
        </div>
      </div>

      <div class="form-group col-sm-6">
        <label for="PhoneMobile">Telefon mobil</label>
        <input class="form-control" v-model="accountInfo.mobilePhone" placeholder="Telefon mobil" type="text" id="PhoneMobile" name="PhoneMobile" value="">
      </div>

    </div>

    <button v-if="accountStatus == 10" class="btn btn-primary" name="button" value="createaccount" @click="onCreateAccount()" :disabled="loading">
      <div class="spinner-border text-white mr-2" role="status" v-if="loading">
        <span class="sr-only">Loading...</span>
      </div>
      Werkstatt-Konto erstellen
    </button>

    <button v-else class="btn btn-primary" name="button" value="createaccount" @click="onUpdateAccount()" :disabled="loading">
      <div class="spinner-border text-white mr-2" role="status" v-if="loading">
        <span class="sr-only">Loading...</span>
      </div>
      Werkstatt-Konto speichern
    </button>

    <button class="btn" name="button" @click="onCancelAccount()">
      Abbrechen
    </button>

    <div class="bg-soft-danger p-3 mt-4" v-if="formdata_errors_account.includes('api')">
      Es gab einen Fehler bei der Übermittlung der Daten. Bitte <a href="mailto:support@booklyn.io">kontaktieren</a> Sie uns.
    </div>

    <div class="mt-4 text-danger"><small>* = Erforderlich</small></div>

  </form>

  </div>
</template>

<script>
export default {
  name: 'KSRShopAccount',
  props: {
    studioId: {
      type: [String, Number],
      required: true
    },
    identityToken: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      accountStatus: false,
      accountInfo: {
        salutation: '',
        firstName: '',
        lastName: '',
        additionalText: '',
        mobilePhone: '',
        eMail: '',
        street: '',
        zipCode: '',
        city: ''
      },
      accountInfoFull: {},
      token: null,
      loading: false,
      formdata_errors_account: [],
      content: {}
    }
  },
  created() {
    this.fetchUserStatus();
  },
  methods: {
    async fetchUserStatus() {
      if (!this.identityToken) return;

      try {
        const url = `/api/ksr/${this.studioId}/userstatus?identityToken=${this.identityToken}`;
        const response = await axios.get(url);

        if (response?.data?.info?.value == null) {
          // Customer has no workshop account yet
          this.accountStatus = 10;
          this.$emit('account-status-changed', 10);
        } else {
          // Customer has workshop account
          const customerIdentity = response.data.info.value.customerIdentity;
          this.accountInfo.salutation = customerIdentity.salutation;
          this.accountInfo.firstName = customerIdentity.firstName;
          this.accountInfo.lastName = customerIdentity.lastName;
          this.accountInfo.additionalText = customerIdentity.additionalText;
          this.accountInfo.mobilePhone = customerIdentity.contactInformation.mobilePhone;
          this.accountInfo.eMail = customerIdentity.contactInformation.eMail;
          this.accountInfo.street = customerIdentity.postalAddress.street;
          this.accountInfo.zipCode = customerIdentity.postalAddress.zipCode;
          this.accountInfo.city = customerIdentity.postalAddress.city;
          this.accountInfoFull = response.data.info.value;
          this.token = response.data.token;
          this.accountStatus = 20; // Has workshop account
          this.$emit('account-status-changed', 20);
        }
      } catch (error) {
        console.error('Error fetching user status:', error);
      }
    },
    validateAccountForm() {
      this.formdata_errors_account = [];

      if (!this.accountInfo.firstName?.trim()) {
        this.formdata_errors_account.push('firstName');
      }
      if (!this.accountInfo.lastName?.trim()) {
        this.formdata_errors_account.push('lastName');
      }
      if (!this.accountInfo.street?.trim()) {
        this.formdata_errors_account.push('street');
      }
      if (!this.accountInfo.zipCode?.trim()) {
        this.formdata_errors_account.push('zipCode');
      }
      if (!this.accountInfo.city?.trim()) {
        this.formdata_errors_account.push('city');
      }

      return this.formdata_errors_account.length === 0;
    },
    onAccount() {
      // Form submit handler - prevent default, actual action handled by buttons
    },
    onCreateAccount() {
      this.formdata_errors_account = [];

      if (this.accountInfo.firstName == '') {
        this.formdata_errors_account.push('firstName');
      }
      if (this.accountInfo.lastName == '') {
        this.formdata_errors_account.push('lastName');
      }
      if (this.accountInfo.street == '') {
        this.formdata_errors_account.push('street');
      }
      if (this.accountInfo.zipCode == '') {
        this.formdata_errors_account.push('zipCode');
      }
      if (this.accountInfo.city == '') {
        this.formdata_errors_account.push('city');
      }

      // Scroll to first error
      if (this.formdata_errors_account.length) {
        setTimeout(() => {
          const element = document.querySelector('.invalid-feedback');
          if (element) element.scrollIntoView();
        }, 200);
        return;
      }

      this.loading = true;
      const _this = this;

      axios.put(`/api/ksr/${this.studioId}/account?identityToken=${this.identityToken}`, this.accountInfo)
        .then((response) => {
          if (response.status == 200) {
            _this.fetchUserStatus();
          }
          _this.loading = false;
        })
        .catch((error) => {
          _this.loading = false;
          _this.formdata_errors_account.push('api');
        });
    },
    async onUpdateAccount() {
      if (!this.validateAccountForm()) return;

      this.loading = true;
      try {
        const url = `/api/ksr/${this.studioId}/updateaccount?identityToken=${this.identityToken}`;
        await axios.post(url, this.accountInfo);
        await this.fetchUserStatus();
      } catch (error) {
        console.error('Error updating account:', error);
        this.formdata_errors_account.push('api');
      } finally {
        this.loading = false;
      }
    },
    onCancelAccount() {
      // Reset form to original values
      this.fetchUserStatus();
    }
  }
}
</script>